import { render, staticRenderFns } from "./applicantsTable.vue?vue&type=template&id=27d6e7de&"
import script from "./applicantsTable.vue?vue&type=script&lang=js&"
export * from "./applicantsTable.vue?vue&type=script&lang=js&"
import style0 from "./applicantsTable.vue?vue&type=style&index=0&id=27d6e7de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports